import InputField from '@/components/_rebrand/InputField';
import { HubspotFieldLabels, HubspotFieldNames } from '@/constants/hubspot';
import { TrialSignupPayload } from '@/constants/trial';
import { FormikProps } from 'formik';
import { FC, useState } from 'react';
import { ButtonElement } from '../Button';
import { PasswordFieldTooltip } from './PasswordFieldTooltip';
import { TrialFormStepFields } from './TrialPersonalInfoForm';

// Password has to be optional in order to be deleted in the alternate secondary form
export type TrialEmailPasswordFormValues = Pick<TrialSignupPayload, HubspotFieldNames.Email | 'password'> & {
  [HubspotFieldNames.MarketingEmailOptOut]: boolean;
};

type TrialEmailPasswordFormProps = {
  formik: FormikProps<TrialFormStepFields>;
}

const TrialEmailPasswordForm: FC<TrialEmailPasswordFormProps> = ({ formik }) => {
  const [passwordFieldFocus, setPasswordFieldFocus] = useState(false);

  return (
    <form className="flex flex-col gap-y-s" onSubmit={formik.handleSubmit} noValidate>
      <InputField
        type="email"
        name={HubspotFieldNames.Email}
        label={HubspotFieldLabels.Email}
        placeholder="you@company.com"
        value={formik.values[HubspotFieldNames.Email]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        errorMessage={formik.errors[HubspotFieldNames.Email] as string}
      />
      <div className="relative">
        <InputField
          type="password"
          name="password"
          label="Choose a password"
          placeholder="Password"
          value={formik.values['password']}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          onFocus={() => setPasswordFieldFocus(true)}
          errorMessage={formik.errors['password']}
          helpMessage="8 characters minimum, and at least 1 uppercase letter and 1 number"
        />
        {passwordFieldFocus && formik.values['password'] && formik.errors['password'] ? (
          <PasswordFieldTooltip password={formik.values['password']} />
        ) : null}
      </div>
      <ButtonElement
        variant="primary"
        buttonType="filled"
        text={formik.isSubmitting ? 'Submitting...' : 'Next'}
        disabled={formik.isValidating || formik.isSubmitting}
      />
    </form>
  );
};

export default TrialEmailPasswordForm;
